/** URL `?tab=` values for petty work overview. */
export const PettyWorkOverviewTabParam = {
  OVERVIEW: "overview",
  MATERIAL_REQUESTS: "material-requests",
  ATTACHMENTS: "attachments",
} as const;

export type PettyWorkOverviewTabParamValue =
  (typeof PettyWorkOverviewTabParam)[keyof typeof PettyWorkOverviewTabParam];

const TAB_ID_TO_PARAM: Record<string, PettyWorkOverviewTabParamValue> = {
  "1": PettyWorkOverviewTabParam.OVERVIEW,
  "2": PettyWorkOverviewTabParam.MATERIAL_REQUESTS,
  "3": PettyWorkOverviewTabParam.ATTACHMENTS,
};

const PARAM_TO_TAB_ID: Record<string, string> = {
  [PettyWorkOverviewTabParam.OVERVIEW]: "1",
  [PettyWorkOverviewTabParam.MATERIAL_REQUESTS]: "2",
  [PettyWorkOverviewTabParam.ATTACHMENTS]: "3",
  // Legacy param — line items moved into an accordion on the Overview tab.
  "line-items": "1",
};

export function pettyWorkOverviewTabIdFromSearchParam(tab: string | null): string {
  if (!tab) return "1";
  return PARAM_TO_TAB_ID[tab] ?? "1";
}

export function searchParamForPettyWorkOverviewTabId(
  tabId: string,
): PettyWorkOverviewTabParamValue | null {
  return TAB_ID_TO_PARAM[tabId] ?? null;
}

export function isValidPettyWorkOverviewTabParam(tab: string | null): boolean {
  if (!tab) return false;
  return Object.prototype.hasOwnProperty.call(PARAM_TO_TAB_ID, tab);
}
